import { NULL_VALUE } from 'components/internal/shared';

export function getScoreType(scoreType) {
  switch (scoreType) {
    case 'StandardScore':
      return 'Creative Quality';
    case 'CustomScore':
      return 'Creative Multiplier';
    default:
      return NULL_VALUE;
  }
}
